const S18_LeafScatter=[
    {
        "group": "S18",
        "sample": "ZY15DAP_1",
        "sample_group": "ZY15DAP",
        "PC1": -34.6779410211767,
        "PC2": 15.1636419878638
    },
    {
        "group": "S18",
        "sample": "ZY15DAP_2",
        "sample_group": "ZY15DAP",
        "PC1": -25.5360222321336,
        "PC2": 17.977794827085
    },
    {
        "group": "S18",
        "sample": "ZY15DAP_3",
        "sample_group": "ZY15DAP",
        "PC1": -35.1550444306088,
        "PC2": 16.8291917119189
    },
    {
        "group": "S18",
        "sample": "ZY12DAP_1",
        "sample_group": "ZY12DAP",
        "PC1": 2.82965714386774,
        "PC2": 22.2831009957934
    },
    {
        "group": "S18",
        "sample": "ZY12DAP_2",
        "sample_group": "ZY12DAP",
        "PC1": -0.867485657074876,
        "PC2": 19.293054798983
    },
    {
        "group": "S18",
        "sample": "ZY12DAP_3",
        "sample_group": "ZY12DAP",
        "PC1": -2.02888793245856,
        "PC2": 19.5591684270608
    },
    {
        "group": "S18",
        "sample": "ZY9DAP_1",
        "sample_group": "ZY9DAP",
        "PC1": 39.4202819901274,
        "PC2": 18.3631474653758
    },
    {
        "group": "S18",
        "sample": "ZY9DAP_2",
        "sample_group": "ZY9DAP",
        "PC1": 33.6572667205738,
        "PC2": 16.0673443141178
    },
    {
        "group": "S18",
        "sample": "ZY9DAP_3",
        "sample_group": "ZY9DAP",
        "PC1": 36.5737800306525,
        "PC2": 19.3813265530136
    },
    {
        "group": "S18",
        "sample": "CA15DAP_1",
        "sample_group": "CA15DAP",
        "PC1": -44.4485175264778,
        "PC2": -1.5994031213265
    },
    {
        "group": "S18",
        "sample": "CA15DAP_2",
        "sample_group": "CA15DAP",
        "PC1": -35.3232986188524,
        "PC2": -11.2264119905054
    },
    {
        "group": "S18",
        "sample": "CA15DAP_3",
        "sample_group": "CA15DAP",
        "PC1": -39.0759842067705,
        "PC2": -15.8444066665503
    },
    {
        "group": "S18",
        "sample": "CA12DAP_1",
        "sample_group": "CA12DAP",
        "PC1": -5.13685456044445,
        "PC2": -30.1774608029455
    },
    {
        "group": "S18",
        "sample": "CA12DAP_2",
        "sample_group": "CA12DAP",
        "PC1": -4.77830745931465,
        "PC2": -28.8970819875123
    },
    {
        "group": "S18",
        "sample": "CA12DAP_3",
        "sample_group": "CA12DAP",
        "PC1": -2.86956398438083,
        "PC2": -29.4472336632962
    },
    {
        "group": "S18",
        "sample": "CA9DAP_1",
        "sample_group": "CA9DAP",
        "PC1": 40.2608127029384,
        "PC2": -15.8855120446883
    },
    {
        "group": "S18",
        "sample": "CA9DAP_2",
        "sample_group": "CA9DAP",
        "PC1": 38.6021977492842,
        "PC2": -17.3314122633794
    },
    {
        "group": "S18",
        "sample": "CA9DAP_3",
        "sample_group": "CA9DAP",
        "PC1": 38.5539112922492,
        "PC2": -14.5088485410081
    }
]
const groupedData = S18_LeafScatter.reduce((acc, curr) => {
    // 如果 group 不存在，初始化为一个空数组
    if (!acc[curr.sample_group]) {
        acc[curr.sample_group] = [];
    }
    // 将当前的对象添加到对应 sample_group 的数组中
    acc[curr.sample_group].push(curr);
    return acc;
}, {});
export default groupedData